'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var TOKEN_MARK = 'prism-token';

exports.default = TOKEN_MARK;